import { useQuery } from 'react-query';
import { get } from '../../../lib/api';

export const useFetchConversations = () => {
  const { isFetched, data: conversations, refetch } = useQuery(
    ['conversations'],
    () => get('/api/ai/conversations'),
    {
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      initialData: [],
    },
  );

  return { isFetched, conversations, refetchConversations: refetch };
};
